const landingParallax = document.querySelectorAll('[data-parallax-image]');
const landingContents = document.querySelectorAll('[data-parallax-content]');

landingParallax.forEach((el) => {
  gsap.to(el, {
    y: '-15%',
    scrollTrigger: {
      trigger: el,
      start: 'top 60%',
      end: 'bottom 60%',
      scrub: 2,
      //   markers: true,
    },
  });
});

landingContents.forEach((el) => {
  gsap.to(el, {
    y: '-30%',
    scrollTrigger: {
      trigger: el,
      start: 'top 100%',
      end: 'bottom 60%',
      scrub: 3,
      //   markers: true,
    },
  });
});
